import { ActionIcon, Tooltip } from "@mantine/core";
import React, { forwardRef } from "react";
import { LuRemoveFormatting } from "react-icons/lu";

const ClearStyles = ({ editor, language }) => {
  const handleClearStyles = () => {
    if (editor) {
      editor.chain().focus().clearNodes().unsetAllMarks().run();
    }
  };

  const TooltipComponent = forwardRef((props, ref) => (
    <div ref={ref} {...props} style={{ pointerEvents: "none" }}>
      <LuRemoveFormatting />
    </div>
  ));

  return (
    <div>
      <Tooltip
        classNames={{ tooltip: "tooltip-body" }}
        transitionProps={{ duration: 200 }}
        openDelay={500}
        multiline
        events={{ hover: true, focus: true, touch: true }}
        label={language.TextEditor.ClearStyles}
      >
        <ActionIcon
          className="text-editor-button"
          type="button"
          size="md"
          w="40"
          variant={"subtle"}
          onClick={handleClearStyles}
          color="black"
        >
          <TooltipComponent />
        </ActionIcon>
      </Tooltip>
    </div>
  );
};

export default ClearStyles;
